export default __webpack_public_path__ + "static/B0140-2233cfda9a9138cff2364e15cece23df.png";